<app-button-rectangle [item]="menuTop"></app-button-rectangle>

<div class="flex-container">
    <ng-container *ngFor="let item of menu; let i = index">
        <app-button-square [item]="item"></app-button-square>
    </ng-container>
</div>